var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ticket-list',{attrs:{"tickets":_vm.tickets},on:{"onRowClick":_vm.onRowClick}}),_vm._v(" "),_c('pagination',{staticStyle:{"text-align":"center"},attrs:{"total-page":_vm.list.totalPage},on:{"change":_vm.onPageChange},model:{value:(_vm.list.pageIndex),callback:function ($$v) {_vm.$set(_vm.list, "pageIndex", $$v)},expression:"list.pageIndex"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3fc4450a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/RecentTickets.vue
// module id = L3nL
// module chunks = 1